<script>
export default {
  props: {
    module: {
      type: Object,
    },
  },
};
</script>
<template>
  <Card class="p-t-c-lf" style="height: 162px">
    <FBody
      :module="module"
    >
      <RowSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('dates')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('duration')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('tourist')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('tour')"
          />
        </ColSpan>
      </RowSpan>
      <RowSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('departure')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('city')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FItem
            :module="module.getItem('type')"
          />
        </ColSpan>
        <ColSpan
          span="3"
        >
          <FBtn>
            <BtnPrimary
              @click="$emit('submit')"
            >
              Найти
            </BtnPrimary>
          </FBtn>
        </ColSpan>
      </RowSpan>
    </FBody>
  </Card>
</template>
<style lang="scss">
  @media (max-width: 1000px) {
    .p-t-c-lf {
      .col-span--3 {
        width: 50%;
      }
    }
  }
  @media (max-width: 500px) {
    .p-t-c-lf {
      .col-span--3 {
        width: 100%;
      }
    }
  }
</style>
